import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import PersonImg from '../images/testimonial-person.png';
import Review1 from '../images/reviewer-01.jpg';
import Review2 from '../images/reviewer-02.jpg';

import './style.css';

const testimonials = [
  {
    name: 'Linda Mary',
    role: 'CEO, Marketing',
    review: Review1,
    quote:
      'Working with SJ Social Media was a game-changer. Their team brought our ideas to life and drove real engagement. Highly recommended!',
  },
  {
    name: 'James Carter',
    role: 'Founder, TechStart',
    review: Review2,
    quote:
      'They understood our business, executed flawlessly, and helped us scale. The support and creativity are unmatched.',
  },
];

function TestimonialsSection() {
  const settings = {
    dots: true,
    arrows: false,
    autoplay: true,
    speed: 600,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <section id="testimonials" className="testimonials-section">
      <Container>
        <Row className="align-items-center">
          <Col md="6" className="text-center mb-4 mb-md-0">
            <img
              src={PersonImg}
              alt="Customer"
              className="img-fluid testimonials-person-img"
            />
          </Col>

          <Col md="6">
            <h2 className="fw-bold mb-2 testimonials-title">
              Testimonials
            </h2>
            <p className="lead mb-4 testimonials-lead">
              See what our clients have to say about working with us.
            </p>

            <div className="testimonials-slider-container">
              <Slider {...settings}>
                {testimonials.map((item, index) => (
                  <div key={index}>
                    <div className="testimonials-reviewer-header">
                      <img
                        src={item.review}
                        alt={item.name}
                        className="testimonials-reviewer-img"
                      />
                      <div>
                        <div className="testimonials-reviewer-name">
                          {item.name}
                        </div>
                        <div className="testimonials-reviewer-role">
                          {item.role}
                        </div>
                      </div>
                    </div>
                    <div className="testimonials-quote">
                      {item.quote}
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default TestimonialsSection;
